import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CatalogReportSearchService } from '@http/clients/reporting-app/custom-report/catalog-report-search.service';
import {
    CustomReportSearchService,
    IReportsSearchService
} from '@http/clients/reporting-app/custom-report/custom-report-search.service';
import { ReportTemplateService } from '@http/clients/reporting-app/report-template.service';
import { CustomReportView, ReportTemplateView } from '@reporting-proxies';
import { TabCounterType } from '@services/tab-counter.service';
import { SectionHeaderComponent } from '@shared/section-header/section-header.component';
import { CounterBadgeComponent, TabItemComponent, TabViewComponent } from 'ngx-lib';
import { ReportsListComponent } from '../reports-list/reports-list.component';

interface IReportsTabConfig<IReportsSearchService> {
    name: string;
    service: IReportsSearchService;
}

@Component({
    selector: 'app-reports-main',
    templateUrl: './reports-main.component.html',
    styleUrls: ['./reports-main.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SectionHeaderComponent, TabViewComponent, TabItemComponent, CounterBadgeComponent, ReportsListComponent]
})
export class ReportsMainComponent {
    @ViewChild(TabViewComponent)
    tabControl!: TabViewComponent;

    currentTab: string;

    tabConfig: IReportsTabConfig<IReportsSearchService<CustomReportView | ReportTemplateView>>[];

    tabsCounters: TabCounterType = {
        User: 0,
        Catalog: 0,
        Templates: 0
    };

    constructor(
        private readonly customReportSearchService: CustomReportSearchService,
        private readonly catalogReportSearchService: CatalogReportSearchService,
        private readonly reportTemplateService: ReportTemplateService
    ) {
        this.currentTab = 'User';

        this.tabConfig = [
            {
                name: 'User',
                service: this.customReportSearchService
            },
            {
                name: 'Catalog',
                service: this.catalogReportSearchService
            },
            {
                name: 'Templates',
                service: this.reportTemplateService
            }
        ];
    }

    async updateCounters(count: number, tabName: string): Promise<void> {
        this.tabsCounters[tabName] = count;
    }
}
